
import React, { useState } from "react";
import './TheTeam.css';
import { Col, Container, Row } from 'react-bootstrap';
import avatar from '../../images/img_avatar.png';

const chairman = [`An accomplished entrepreneur
with over 20 years of experience
    in Project Manager positions
for Enterprise type`, 2, 3]

const ceo = [`Over 20 years of international
business development and
product marketing experience (VP
and CEO level)`, `abc`, `def`]

const coFounder = [`Experienced Backend Engineer,
responsible for building an
efficient infrastructure for
processing data of`, `abc`, `def`]

const rdManager = [`Experienced Backend Engineer,
responsible for building an
efficient infrastructure for
processing data of`, `abc`, `def`]

function TheTeam() {
    return (
        <section>
            <div  id='team' className="">
                <Container fluid>
                    <Row className='col-op-first'>
                        <Col lg={6}>
                            <div className='col-sol-first-div'>
                                <h1>
                                    The Team
                                </h1>
                            </div>
                        </Col>
                        <Col lg={6}>
                        </Col>
                    </Row>
                </Container>
                <Container fluid>
                    <Row className='team-col-op'>
                        <Col lg={3} md={6} sm={12}>
                            <TeamCard
                                image={avatar}
                                name='Eran Gilat'
                                title='Chairman and Co-Founder'
                                descp={chairman}
                            />
                        </Col>
                        <Col lg={3} md={6} sm={12}>
                            <TeamCard
                                image={avatar}
                                name='Yoav Tomer'
                                title='CEO and Co-founder'
                                descp={ceo}
                            />
                        </Col>
                        <Col lg={3} md={6} sm={12}>
                            <TeamCard
                                image={avatar}
                                name='Shauli Rajuan'
                                title='Co-Founder'
                                descp={coFounder}
                            />
                        </Col>
                        <Col lg={3} md={6} sm={12}>
                            <TeamCard
                                image={avatar}
                                name='David David'
                                title='R&D Manager'
                                descp={rdManager}
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        </section>
    )
}

export default TheTeam;



const ReadMore = ({ children }) => {
    const text = children;
    console.log('text', text.props.children[0].props.children.slice(0,110))
    const displayText =  text.props.children[0].props.children.slice(0,110)
    const [isReadMore, setIsReadMore] = useState(true);
    const toggleReadMore = () => {
        setIsReadMore(!isReadMore);
    };
    return (
        <p className="text">
            {isReadMore ?  (
                <ul>
                    <li>
                    {displayText.slice(0, 90)}
                    </li>
                </ul>
            ) : text}
            <span onClick={toggleReadMore} className="read-or-hide">
                {isReadMore ? "...read more" : " show less"}
            </span>
        </p>
    );
}



function TeamCard(props) {
    return (
        <div className='team-wrapper'>
            <div className="team-img">
                <img src={props.image} alt="" />
            </div>
            <div className="team-line"></div>
            <div className="team-name">
                <h2>{props.name}</h2>
            </div>
            <div className="team-title">
                <p>{props.title}</p>
            </div>
            <div className="team-descp">
                <ReadMore>
                    <ul className='pakh'>
                        {props.descp.map((v, i) => {
                            return (
                                <li key={i}>
                                    {v}
                                </li>
                            )
                        })}
                    </ul>
                </ReadMore>
            </div>
        </div>
    )
}
